import type { CardSeriesPoint } from '@ctd/agent-contract';

export interface SeriesDay {
    date: string;
    value: number | null;
}

/** The days of one metric, oldest first; the ids are the agent's, so only a day's own keys count. */
export function seriesOf(
    series: CardSeriesPoint[],
    metricId: string
): SeriesDay[] {
    return series
        .map(({ date, values }) => ({
            date,
            value:
                Object.entries(values).find(([id]) => id === metricId)?.[1] ??
                null,
        }))
        .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
}
